var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flickity',{staticClass:"hd-carousel",attrs:{"options":_vm.flickityOptions},on:{"init":_vm.onFlickityInit}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }